import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useMsal } from "@azure/msal-react";
import "./AccountMenu.scss";
import api from "../../../axios/axios";

const AccountMenu = ({ className }: { className: string }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { instance, accounts } = useMsal();

  const logout = () => {
    instance
      .logoutRedirect()
      .then(() => {
        api.defaults.headers.common["Authorization"] = "";
      })
      .catch((e) => {
        throw new Error(e);
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (event: { currentTarget: any }) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={className}>
      <IconButton
        size="large"
        color="inherit"
        aria-controls="account-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <span id="account-name">
          {accounts.length > 0 ? accounts[0].name : ""}
        </span>
        <AccountCircleIcon />
      </IconButton>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <ExitToAppIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Logout</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default AccountMenu;
